<h2 class="float-left">{{ title | translate }}</h2>

<div class="mb-5"></div>
<app-simple-table-wrapper [parentComponent]="'AccountHistoryComponent'" [tableDetails]="tableDetails" [filterParams]="filterParams"></app-simple-table-wrapper>

 <div class="d-flex justify-content-end button-panel">
  <button type="button" class="btn btn-secondary" (click)="returnPreviousLocation($event)" >{{'ACCOUNTS_MODULE.accountHistory.close' | translate}}</button>
</div>